<script lang="ts">
  export let ambassadors: readonly {
    name: string
    image: string
    description: string
    quote: string
  }[]

  let clientHeight: number
  let offsetHeight: number
  let list: HTMLUListElement | undefined
  let dragging = false
  let startX: number
  let scrollLeft: number
  $: overflow = offsetHeight > clientHeight

  $: if (overflow && list) {
    list.addEventListener('mousemove', drag)
    list.addEventListener('mousedown', startDragging)
    list.addEventListener('mouseup', stopDragging)
    list.addEventListener('mouseleave', stopDragging)
  } else if (list) {
    list.removeEventListener('mousemove', drag)
    list.removeEventListener('mousedown', startDragging)
    list.removeEventListener('mouseup', stopDragging)
    list.removeEventListener('mouseleave', stopDragging)
  }

  function startDragging(event: MouseEvent) {
    if (list) {
      dragging = true
      startX = event.pageX - list.offsetLeft
      scrollLeft = list.scrollLeft
    }
  }

  function stopDragging() {
    dragging = false
  }

  function drag(event: MouseEvent) {
    event.preventDefault()

    if (dragging && list) {
      const scroll = event.pageX - list.offsetLeft - startX
      list.scrollLeft = scrollLeft - scroll
    }
  }
</script>

<section class="container">
  <ul bind:clientHeight bind:offsetHeight class:overflow bind:this={list}>
    {#each ambassadors as ambassador, index (index)}
      <li>
        <img src={ambassador.image} alt={ambassador.name} loading="lazy" />
        <h3>{ambassador.name}</h3>
        <div class="desciption">{ambassador.description}</div>
        <p>{ambassador.quote}</p>
      </li>
    {/each}
  </ul>
</section>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .container {
    box-sizing: border-box;
    padding: 2em 2em 0 2em;
    max-width: 100%;
    background-color: var(--ambassadors-background, transparent);
    color: #fff;

    @media screen and (max-width: breakpoints.$breakpoint-sm) {
      padding: 1em 1em 0 1em;
    }

    ul {
      display: flex;
      gap: 2em;
      list-style: none;
      padding: 0 0 2em 0;
      margin: 0;
      overflow-x: auto;

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        gap: 1em;
      }

      &.overflow {
        cursor: grab;
      }

      li {
        flex: 1;
        min-width: 240px;

        img {
          width: 100%;
        }

        h3 {
          font-size: 20px;
          color: var(--cardio-green);
        }

        div {
          font-weight: 600;
          opacity: 0.5;
        }

        p {
          font-size: 16px;

          &:before {
            content: open-quote;
          }

          &:after {
            content: close-quote;
          }
        }
      }
    }
  }
</style>
